
    require('./graphic');
    require('../zrender').registerPainter('vml', require('./Painter'));



//////////////////
// WEBPACK FOOTER
// ./~/zrender/lib/vml/vml.js
// module id = 996
// module chunks = 0